import { render, staticRenderFns } from "./AttributiProdotto.vue?vue&type=template&id=313f8736&scoped=true&"
import script from "./AttributiProdotto.vue?vue&type=script&lang=js&"
export * from "./AttributiProdotto.vue?vue&type=script&lang=js&"
import style0 from "./AttributiProdotto.vue?vue&type=style&index=0&id=313f8736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313f8736",
  null
  
)

export default component.exports